import type { CardBrand } from '@heybesafe/shared';

/** Human-readable name for a derived card network, for display in the My
 *  Payment Cards surface. `unknown` (empty/unrecognized number) shows as
 *  "Card" so a row never reads "Unknown". */
const CARD_BRAND_LABELS: Record<CardBrand, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
  maestro: 'Maestro',
  unknown: 'Card',
};

export function cardBrandLabel(brand: CardBrand | undefined): string {
  return CARD_BRAND_LABELS[brand ?? 'unknown'];
}
